import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { AbstractComponent, Webhook } from 'lib-trend-core'

@Component({
    selector: 'webhook-view-edit',
    templateUrl: './webhook-view.component.html',
    styleUrls: ['./webhook-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WebhookViewComponent extends AbstractComponent {
  
  constructor(
    injector: Injector,
    @Inject(MAT_DIALOG_DATA) public webhook: Webhook,
    private dialogRef: MatDialogRef<WebhookViewComponent>,
  ) {
    super(injector)
  }

  onClose(): void {
    this.dialogRef.close()
  }

}
